import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import Button from '../../components/buttons/Button';

const AlarmsModalHeaderWrapper = styled.div`
  .alarmsheader {
    display: flex;
    overflow: auto;
    background-color: ${getTheme('black', '_950')};
    padding: ${getTheme('padding', 'verticalM')} ${getTheme('padding', 'horizontalXL')};

    &__section {
      display: flex;
      flex-shrink: 0;
      border-right: 1px solid ${getTheme('black', '_800')};
      margin-right: ${getTheme('spacer', 'm')};
      padding-right: ${getTheme('padding', 'horizontalM')};
    }
    &__unit {
      flex-shrink: 0;
      padding: ${getTheme('padding', 'verticalM')} ${getTheme('padding', 'horizontalM')};
    }
    &__section .alarmsheader__unit:first-child {
      padding-left: 0;
    }
    &__label {
      text-transform: uppercase;
      font-weight: 600;
      font-size: ${getTheme('fontSize', 'small')};
    }
    &__text {
      font-size: ${getTheme('fontSize', 'body')};
      font-weight: 800;
    }
    &__text--limited {
      max-width: 18em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &__text-date {
      font-size: ${getTheme('fontSize', 'body')};
      font-weight: 300;
    }
  }
`;

class AlarmsModalHeader extends Component {
  render() {
    return (
      <AlarmsModalHeaderWrapper>
        <div className="alarmsheader">
          <div className="alarmsheader__section">
            <div className="alarmsheader__unit">
              <div className="alarmsheader__label">Date created</div>
              <div className="alarmsheader__text-date">
                {this.props.item.date} · {this.props.item.time}
              </div>
            </div>
            <div className="alarmsheader__unit">
              <div className="alarmsheader__label">Daily count</div>
              <div className="alarmsheader__text">
                <Button pill size="xsmall" noMarginBottom>
                  {this.props.item.sec}
                </Button>
              </div>
            </div>
          </div>
          <div className="alarmsheader__unit">
            <div className="alarmsheader__label">UT</div>
            <div className="alarmsheader__text">{this.props.item.ut}</div>
          </div>
          <div className="alarmsheader__unit">
            <div className="alarmsheader__label">Group</div>
            <div className="alarmsheader__text">{this.props.item.groupid}</div>
          </div>
          <div className="alarmsheader__unit">
            <div className="alarmsheader__label">Trigger</div>
            <div className="alarmsheader__text">{this.props.item.triggerid}</div>
          </div>
          <div className="alarmsheader__unit">
            <div className="alarmsheader__label">Alarms</div>
            <div className="alarmsheader__text alarmsheader__text--limited">
              {this.props.item.alarms}
            </div>
          </div>
          <div className="alarmsheader__unit">
            <div className="alarmsheader__label">CRC</div>
            <div className="alarmsheader__text">{this.props.item.crc}</div>
          </div>
        </div>
      </AlarmsModalHeaderWrapper>
    );
  }
}

export default AlarmsModalHeader;



// WEBPACK FOOTER //
// ./src/pages/alarms/AlarmsModalHeader.js